import { IconProps } from './icons-props';

function HashtagIcon({ className, width = 18, height = 18 }: IconProps) {
    return (
        <>
            <svg
                className={className}
                width={width}
                height={height}
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M6 16.3126C5.9775 16.3126 5.955 16.3126 5.94 16.3126C5.6325 16.2751 5.4075 15.9976 5.445 15.6901L6.945 2.19015C6.9825 1.88265 7.26 1.66515 7.5675 1.69515C7.875 1.73265 8.1 2.01015 8.0625 2.31765L6.5625 15.8176C6.525 16.1026 6.285 16.3126 6 16.3126Z'
                    fill='currentColor'
                />
                <path
                    d='M10.5 16.3126C10.4775 16.3126 10.455 16.3126 10.44 16.3126C10.1325 16.2751 9.9075 15.9976 9.945 15.6901L11.445 2.19015C11.4825 1.88265 11.7525 1.66515 12.0675 1.69515C12.375 1.73265 12.6 2.01015 12.5625 2.31765L11.0625 15.8176C11.025 16.1026 10.785 16.3126 10.5 16.3126Z'
                    fill='currentColor'
                />
                <path
                    d='M16.125 7.3125H2.625C2.3175 7.3125 2.0625 7.0575 2.0625 6.75C2.0625 6.4425 2.3175 6.1875 2.625 6.1875H16.125C16.4325 6.1875 16.6875 6.4425 16.6875 6.75C16.6875 7.0575 16.4325 7.3125 16.125 7.3125Z'
                    fill='currentColor'
                />
                <path
                    d='M15.375 11.8125H1.875C1.5675 11.8125 1.3125 11.5575 1.3125 11.25C1.3125 10.9425 1.5675 10.6875 1.875 10.6875H15.375C15.6825 10.6875 15.9375 10.9425 15.9375 11.25C15.9375 11.5575 15.6825 11.8125 15.375 11.8125Z'
                    fill='currentColor'
                />
            </svg>
        </>
    );
}

export default HashtagIcon;

